export const texts = {
  EDIT_BUTTON: 'Edit',
  EDIT_POPUP_TITLE: 'Title',
  CONFIRMATION_BUTTON: 'Title',
};
